import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import AdminPanel from './pages/AdminPanel';
import AdminTemplates from './pages/AdminTemplates';
import LawChangesGuide from './pages/LawChangesGuide';
import DayPlanner from './pages/DayPlanner';
import PleadingsLibrary from './pages/PleadingsLibrary';
import VerifyEmail from './pages/VerifyEmail';
import SetPassword from './pages/SetPassword';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './contexts/AuthContext';
import { Toaster, toast } from 'sonner';
import axios from 'axios';
import './App.css';

axios.interceptors.response.use((res) => {
  const auto = parseInt(res.headers?.['x-auto-scheduled-tasks'] || '0', 10);
  if (auto > 0) {
    toast.success(`Τοποθετήθηκαν αυτόματα ${auto} ${auto === 1 ? 'εργασία' : 'εργασίες'} στο πλάνο ημέρας`, { duration: 6000 });
  }
  const moved = res.headers?.['x-auto-moved-to'];
  if (moved) {
    const label = new Date(`${moved}T12:00:00`).toLocaleDateString('el-GR', { day: '2-digit', month: '2-digit', year: 'numeric' });
    toast.info(`Η εργασία τοποθετήθηκε αυτόματα στις ${label} — η ημέρα που επιλέξατε ήταν πλήρης`, { duration: 6000 });
  }
  return res;
});

function App() {
  return (
    <div className="App">
      {/* Landscape blocker on mobile */}
      <div className="rotate-device-overlay" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
          <rect x="5" y="2" width="14" height="20" rx="2" />
          <line x1="12" y1="18" x2="12" y2="18.01" />
        </svg>
        <div style={{ fontSize: 18, fontWeight: 600, marginBottom: 8 }}>Στρέψε τη συσκευή κατακόρυφα</div>
        <div style={{ fontSize: 14, opacity: 0.8 }}>Η εφαρμογή λειτουργεί μόνο σε όρθια προβολή</div>
      </div>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/set-password" element={<SetPassword />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminPanel />
                </ProtectedRoute>
              }
            />
            <Route
              path="/templates"
              element={
                <ProtectedRoute>
                  <AdminTemplates />
                </ProtectedRoute>
              }
            />
            <Route
              path="/law-changes"
              element={
                <ProtectedRoute>
                  <LawChangesGuide />
                </ProtectedRoute>
              }
            />
            <Route
              path="/day-planner"
              element={
                <ProtectedRoute>
                  <DayPlanner />
                </ProtectedRoute>
              }
            />
            <Route
              path="/pleadings"
              element={
                <ProtectedRoute>
                  <PleadingsLibrary />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
